module.exports = __webpack_public_path__ + "static/media/send_icon.a2a7e2e7.svg";